<template>
  <div class="accordion pl-2 pr-2 placeholder-skeleton-wrapper">
    <div class='card p-2 skelo-card-outer'>
      <div 
        class="skelo-accordion-btn d-flex flex-row justify-content-between m-3 accordion-btn">
        <BSkeleton animation="wave" width="70%"></BSkeleton>
        <div class='toggle-open-btn'>
          <i class="fas fa-chevron-up"></i>
        </div>
      </div>
      <div class="card pr-2 skelo-card-inner" v-for="(item, index) in [0,1,2]" :key="index">
        <BRow no-gutters class="skolo-line-r">
          <BCol cols="6" class="skelo-c">
        
            <BSkeletonImg height="100">
            </BSkeletonImg>
          </BCol>
          <BCol cols="6" class="skelo-c">
            <div class="skelo-line-wrapper pl-2">
              <BSkeleton animation="wave" width="85%"></BSkeleton>
              <BSkeleton animation="wave" width="55%"></BSkeleton>
              <BSkeleton animation="wave" width="70%"></BSkeleton>
            </div>
              </BCol>
        </BRow>
      </div>
    </div>
  </div>
</template>

<script>
import { BSkeletonImg, BSkeleton, BCol, BRow } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  components: {
    BSkeletonImg,
    BSkeleton,
    BRow,
    BCol
  }
}
</script>

<style>
   /* for safari */
 .b-aspect-content {
   display: flex;
 }
   /* for safari */
 .b-skeleton-img {
   height: unset;
 }

 .placeholder-skeleton-wrapper .skelo-card .skolo-line-r .skelo-c {
  padding-left: 5px !important;
 }
</style>
